<template>
  <v-container ma-0 pa-0 fluid style="height:100%;" class="pt-sans">
    <v-layout row wrap style="height:100%;">
      <v-flex md6 hidden-sm-and-down style="height:100%;background-color:#ea1d24;">
        <div>
          <img data-src="/static/img/img-login.png" alt="" class="lazyload img-responsive">
          <div class="destaque-login">
            <img data-src="/static/img/icone-cadastro.png" alt="" class="lazyload">
            <h4>Conquiste!</h4>
            <h6>Venda mais para Condomínios! Conheça a ferramenta que coloca sua empresa em contato com quem compra!</h6>
          </div>
        </div>
      </v-flex>
      <v-flex xs12 md6>
        <v-layout row wrap style="height:100%;">
          <v-flex xs10 offset-xs1 sm6 offset-sm3 grid-list-xs pt-5>
            <div class="titulo-logo mb-4 float-l">
              <img src="../../assets/logo.png" alt="">
              <h4>CondoPlaza</h4>
            </div>
            <v-form ref="form" class="mt-5">
              <v-flex xs12 s12 offset-s1 grid-list-xs pt-5>
                <v-text-field
                  label="Usuário"
                  v-model="login"
                  :rules="usuarioRegras"
                  prepend-icon="person"
                  validate-on-blur
                  required
                ></v-text-field>
              </v-flex>
                <v-text-field
                  name="senha"
                  label="Senha"
                  type="password"
                  v-model="senha"
                  validate-on-blur
                  :rules="senhaRegras"
                  v-on:keyup.13="autenticar"
                  prepend-icon="lock_open"
                  required
                ></v-text-field>
                <v-checkbox
                  label="Mantenha-me conectado"
                  v-model="manterLogin"
                  color="teal darken-1"
                >
                entre aequi
                <div class="link">
                  <router-link to="/hello">Não consigo acessar minha conta!</router-link>
                </div>
              </v-checkbox>
              <div class="">
                <v-btn
                  round
                  :loading="loading"
                  @click.native="loader = 'loading'"
                  :disabled="loading"
                  v-on:click='autenticar'
                  class="btn-green"
                >
                  Entrar
                  <span slot="loader" class="custom-loader">
                    <v-icon light>cached</v-icon>
                  </span>
                </v-btn>
              </div>
             </v-form>
             <div class="font-16px">
               <LembreteSenha/>
             </div>
             <div class="font-16px cadastro-footer">
               Não tem uma conta<span> CondoPlaza</span>? <router-link class="link" to="/Cadastro">Cadastre-se</router-link>
             </div>
           </v-flex>
         </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import LembreteSenha from './LembreteSenha'

export default {
  name: 'Login',
  components: {
    LembreteSenha
  },
  data () {
    return {
      formValido: false,
      validacao: 0,
      texto: '',
      usuarioRegras: [
        (v) => !!v || 'Usuario em branco',
        (v) => v.length < 20 || 'Usuario inválido'
      ],
      senhaRegras: [
        (v) => !!v || 'Preencha uma senha'
      ]
    }
  },
  methods: {
    test: function (event) {
      this.usuari.autofocus = true
    },
    autenticar: function (event) {
      if (this.$refs.form.validate()) {
        this.$store.dispatch('autenticar', {
          nomeUsuario: this.login,
          senha: this.senha,
          mantemConectado: this.manterLogin
        }).then(() => {
          this.$router.push('/Painel/Inicio/')
        }).catch((error) => {
          console.log(error)
        })
      }
    }
  },
  computed: {
    loading () {
      return this.$store.getters.loadingAutenticacao
    },
    usuario () {
      return this.$store.getters.usuario
    },
    login: {
      get () {
        return this.usuario.login
      },
      set (value) {
        this.$store.commit('updateLogin', value)
      }
    },
    senha: {
      get () {
        return this.usuario.senha
      },
      set (value) {
        this.$store.commit('updateSenha', value)
      }
    },
    manterLogin: {
      get () {
        return this.usuario.persistencia
      },
      set (value) {
        this.$store.commit('updatePersistencia', value)
      }
    }
  },
  mounted () {
    window.lazyload()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.titulo-logo img{
  width: 60px;
  height: 60px;
  float: left;
}
.titulo-logo h4{
  width: calc(100% - 60px);
  color: #a2a2a2;
  float: left;
  position: relative;
  top: 7px;
  left: 25px;
}

.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
.destaque-login{
  color: #f3fdfe;
  padding: 30px;
}
.destaque-login img{
  float: left;
  width: 60px;
}
.destaque-login h4{
  float: left;
  width: calc(100% - 60px);
  padding: 7px 10px;
  font-weight: bold;
}
.destaque-login h6{
  padding-top: 7px;
  float: left;
  width: 100%;
}
.font-16px{
  font-size: 16px;
}
.float-l{
  float: left
}

@media only screen and (max-width: 643px){
  .cadastro-footer{
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    color: #fff;
    background-color: #ea1d24;
    text-align: center;
    padding: 10px;
  }
  .cadastro-footer a{
    color: #fff!important;
    font-weight: bold;
  }
  .cadastro-footer span{
    display: none;
  }
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?7465e622